export default __webpack_public_path__ + "static/media/logo_top.c908d40d.png";